import { Component, type ErrorInfo, type ReactNode } from 'react'

interface ErrorBoundaryProps {
  /** Rendered instead of the children once they throw. Defaults to nothing. */
  fallback?: ReactNode
  /** Names the boundary in the console warning. */
  name?: string
  children: ReactNode
}

/**
 * Contains a render or lazy-load failure to the part of the page that caused it.
 * Without one, React unmounts the whole app, so e.g. a stale map chunk after a
 * deploy blanked the entire directory page (issue #97).
 */
export class ErrorBoundary extends Component<ErrorBoundaryProps, { failed: boolean }> {
  state = { failed: false }

  static getDerivedStateFromError() {
    return { failed: true }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.warn(`[ErrorBoundary${this.props.name ? `:${this.props.name}` : ''}]`, error, info.componentStack)
  }

  render() {
    return this.state.failed ? (this.props.fallback ?? null) : this.props.children
  }
}
